import type { SavedViewConfig } from "@/lib/types/table";
import { PENDING_SEND_STATUSES, SENT_STATUSES } from "./options";

/**
 * Saved views for the email campaigns list. Mirrors the social-media-posts
 * saved-view split (All + status slices). `filter_status` is the generic status
 * filter key the filter-conversion service maps onto the GraphQL `status` column.
 */
export const emailCampaignSavedViews: SavedViewConfig[] = [
  {
    id: "all-email-campaigns",
    name: "All",
    filters: {},
    isDefault: true,
  },
  {
    id: "drafts",
    name: "Drafts",
    filters: { filter_status: ["draft"] },
  },
  {
    id: "scheduled",
    name: "Scheduled",
    filters: { filter_status: [...PENDING_SEND_STATUSES] },
  },
  {
    id: "sent",
    name: "Sent",
    filters: { filter_status: [...SENT_STATUSES] },
  },
  {
    id: "failed",
    name: "Failed",
    filters: { filter_status: ["failed", "partially_failed"] },
  },
];
